import React, { createContext, useContext, useEffect, useState } from "react";

const dict = {
  de: {
    appName: "ALLES GEREGELT",
    appTag: "LIFE CORE",
    tagline: "Sie kaufen keine Software. Sie kaufen das gute Gefühl, dass alles geregelt ist.",
    nav: {
      myLife: "Mein Leben",
      lifeTree: "Lebensbaum",
      vault: "Vault",
      tasks: "Aufgaben",
      emergency: "Notfall",
      family: "Familie",
      trustCard: "Vertrauenskarte",
      settings: "Einstellungen",
    },
    auth: {
      login: "Anmelden",
      register: "Konto erstellen",
      email: "E-Mail",
      password: "Passwort",
      firstName: "Vorname",
      lastName: "Nachname",
      orDivider: "oder",
      google: "Mit Google anmelden",
      demoTitle: "Demo-Modus",
      demoSub: "Sehen Sie die App mit den Daten von Stefan Muster.",
      demoStart: "Demo-Modus starten",
      noAccount: "Noch kein Konto?",
      hasAccount: "Bereits ein Konto?",
      welcome: "Willkommen zurück",
      welcomeNew: "Schön, dass Sie da sind",
      submitLogin: "Anmelden",
      submitRegister: "Konto erstellen",
      logout: "Abmelden",
    },
    onboarding: {
      step1Title: "Schön, dass Sie da sind.",
      step1Sub: "Niemand muss alles an einem Tag erledigen. Schon 10 Minuten reichen aus, um heute etwas Wichtiges zu regeln.",
      step2Title: "Was möchten Sie zuerst regeln?",
      step2Sub: "Wählen Sie die Lebensbereiche, die Ihnen wichtig sind. Sie können das jederzeit ändern.",
      step3Title: "Ihr erster Notfallkontakt",
      step3Sub: "Eine Vertrauensperson, die im Ernstfall informiert werden soll.",
      step3Skip: "Diesen Schritt später erledigen",
      step4Title: "Bereit für Ihr Dashboard",
      step4Sub: "Schritt für Schritt. Sie sind sicher hier.",
      continue: "Weiter",
      skip: "Überspringen",
      finish: "Dashboard öffnen",
    },
    dashboard: {
      greeting: (n) => `Guten Morgen, ${n}.`,
      subline: "Heute können Sie in 8 Minuten drei wichtige Dinge regeln.",
      trustRing: "Vertrauensstatus",
      segments: {
        vollstaendigkeit: "Vollständigkeit",
        aktualitaet: "Aktualität",
        sicherheit: "Sicherheit",
        notfallbereitschaft: "Notfallbereitschaft",
      },
      thisWeek: (d) => `+${d}% diese Woche`,
      openTasks: "Offene Empfehlungen",
      seeAll: "Alle anzeigen",
      lifeTree: "Lebensbaum",
    },
    statuses: {
      alles_geregelt: "Alles geregelt",
      teilweise_geregelt: "Teilweise geregelt",
      handlungsbedarf: "Handlungsbedarf",
    },
    vault: {
      title: "Dokumententresor",
      subtitle: "Ihre wichtigen Dokumente. Sicher übertragen. Verschlüsselt gespeichert. Übersichtlich.",
      upload: "Dokument hochladen",
      search: "Suchen...",
      all: "Alle",
      empty: "Noch keine Dokumente gespeichert. Laden Sie Ihr erstes wichtiges Dokument hoch und schaffen Sie heute ein Stück mehr Sicherheit.",
      titleField: "Titel",
      category: "Kategorie",
      description: "Beschreibung",
      tags: "Tags (kommagetrennt)",
      expiry: "Ablaufdatum",
      reminder: "Erinnerungsdatum",
      file: "Datei auswählen",
      save: "Hochladen",
      cancel: "Abbrechen",
      open: "Öffnen",
      edit: "Bearbeiten",
      delete: "Löschen",
      categories: {
        ausweise: "Ausweise",
        gesundheit: "Gesundheit",
        versicherungen: "Versicherungen",
        finanzen: "Finanzen",
        zuhause: "Zuhause",
        familie: "Familie",
        vorsorge: "Vorsorge",
        nachlass: "Nachlass",
        business: "Business",
        sonstiges: "Sonstiges",
      },
    },
    tasks: {
      title: "Aufgaben & Empfehlungen",
      subtitle: "Kleine Schritte. Große Wirkung.",
      empty: "Aktuell gibt es nichts Dringendes. Genießen Sie Ihren Tag.",
      done: "Erledigen",
      later: "Später",
      priorityHigh: "Hoch",
      priorityNormal: "Normal",
      priorityLow: "Niedrig",
      minutes: (m) => `${m} Min.`,
      addTask: "Aufgabe hinzufügen",
    },
    emergency: {
      title: "Notfallbereich",
      subtitle: "Dieser Bereich hilft Ihren Angehörigen, im Ernstfall schnell die wichtigsten Informationen zu finden.",
      addContact: "Notfallkontakt hinzufügen",
      empty: "Legen Sie einen Notfallkontakt an, damit im Ernstfall die richtige Person informiert werden kann.",
      access: "Zugriff erlaubt",
      noAccess: "Kein Zugriff",
      relationship: "Beziehung",
      phone: "Telefon",
      email: "E-Mail",
      notes: "Notizen",
      name: "Name",
      save: "Speichern",
      cancel: "Abbrechen",
      delete: "Entfernen",
    },
    family: {
      title: "Familie & Vertrauenspersonen",
      subtitle: "Wer im Ernstfall Zugriff hat. Wer Bescheid weiß.",
    },
    lifeTree: {
      title: "Lebensbaum",
      subtitle: "Neun Bereiche. Ein Leben.",
    },
    settings: {
      title: "Einstellungen",
      language: "Sprache",
      german: "Deutsch",
      english: "Englisch",
      account: "Konto",
      presentation: "Präsentationsmodus",
      presentationSub: "Sanfte Animationen. Vorbereitete Daten. Perfekt für Messen und Investoren.",
      startPresentation: "Präsentation starten",
      stopPresentation: "Präsentation beenden",
      exitDemo: "Demo-Modus verlassen",
      sectionGeneral: "Allgemein",
      sectionProfile: "Profil",
      sectionSecurity: "Sicherheit",
      sectionPrivacy: "Daten & Datenschutz",
    },
    security: {
      profile: {
        title: "Profil",
        name: "Name",
        edit: "Bearbeiten",
        changeEmail: "E-Mail ändern",
        changeEmailSub: "Aus Sicherheitsgründen benötigen wir Ihr aktuelles Passwort, bevor wir Ihre Anmelde-Adresse ändern.",
        newEmail: "Neue E-Mail-Adresse",
        confirmPwd: "Aktuelles Passwort",
        confirmPwdPlaceholder: "Zur Bestätigung",
        authMethod: "Anmelde-Methode",
        googleManaged: "Diese Daten werden über Ihren Google-Account verwaltet.",
        avatarSaved: "Profilbild gespeichert.",
        avatarError: "Profilbild konnte nicht gespeichert werden.",
        nameSaved: "Name aktualisiert.",
        emailSaved: "E-Mail-Adresse aktualisiert.",
        emailError: "E-Mail konnte nicht geändert werden.",
      },
      security: {
        title: "Sicherheit",
        password: "Passwort",
        passwordSub: "Wählen Sie ein Passwort, das Sie sich gut merken können – aber niemand anderes erraten würde.",
        changePassword: "Passwort ändern",
        changePasswordSub: "Geben Sie zur Bestätigung Ihr aktuelles Passwort ein und wählen Sie ein neues.",
        currentPwd: "Aktuelles Passwort",
        pwdSaved: "Passwort gespeichert.",
        pwdError: "Passwort konnte nicht geändert werden.",
        mfa: "Zwei-Faktor-Anmeldung",
        mfaSub: "Zusätzlicher Schutz mit Authenticator-App oder Passkey. Wir bereiten dies sorgfältig vor.",
        mfaMethods: "Geplante Methoden",
        comingSoon: "Bald verfügbar",
        notify: "Benachrichtigen",
        sessions: "Aktive Sitzungen",
        sessionsSub: "Hier sehen Sie, wo Sie aktuell angemeldet sind. Sie können einzelne Sitzungen beenden.",
        sessionsEmpty: "Noch keine Sitzungen erfasst.",
        sessionsNote: "Aus Sicherheitsgründen werden Sitzungen auf neuen Geräten zusätzlich automatisch erfasst.",
        thisDevice: "Dieses Gerät",
        revoke: "Abmelden",
        sessionRevoked: "Sitzung beendet.",
        sessionRevokeError: "Sitzung konnte nicht beendet werden.",
      },
      privacy: {
        title: "Daten & Datenschutz",
        exportTitle: "Daten exportieren",
        exportSub: "Erhalten Sie eine vollständige, maschinenlesbare Kopie aller Ihrer Daten – inkl. Lebensbaum, Vault, Aufgaben, Kontakten und Notfalleinstellungen. (DSGVO Art. 20)",
        exportBtn: "Export herunterladen",
        exportSuccess: "Export wurde heruntergeladen.",
        exportError: "Export konnte nicht erstellt werden.",
        deleteTitle: "Konto löschen",
        deleteSub: "Wenn Sie Ihr Konto schließen, werden Ihre Konto- und Metadaten dauerhaft aus unserer Datenbank entfernt. Für hochgeladene Dateien gelten die in unserer Datenschutzerklärung beschriebenen Speicher- und Löschverfahren. Der Vorgang kann nicht rückgängig gemacht werden.",
        deleteBtn: "Konto schließen",
        deleteConfirmTitle: "Konto endgültig löschen?",
        deleteConfirmIntro: "Sie sind dabei, Ihr Konto und alle damit verbundenen Daten dauerhaft zu entfernen. Bitte nehmen Sie sich einen ruhigen Moment.",
        deleteList: [
          "Ihre Lebensbereiche, Aufgaben und Empfehlungen werden gelöscht.",
          "Alle hochgeladenen Dokumente werden aus dem Vault entfernt.",
          "Ihre Vertrauenskarte wird sofort ungültig.",
          "Ihre Notfallkontakte und Benachrichtigungs-Einstellungen werden entfernt.",
          "Ein Wiederherstellen ist nach Bestätigung nicht mehr möglich.",
        ],
        confirmTypeLabel: (word) => `Tippen Sie zur Bestätigung „${word}"`,
        confirmTypeWrong: "Bitte tippen Sie den Bestätigungstext exakt so ein.",
        deleteFinal: "Ja, Konto endgültig löschen",
        deleteSuccess: "Ihr Konto wurde geschlossen.",
        deleteError: "Konto konnte nicht gelöscht werden.",
      },
    },
    reset: {
      forgotLink: "Passwort vergessen?",
      backToLogin: "Zurück zur Anmeldung",
      heroLine: "Wir helfen Ihnen ruhig und sicher zurück in Ihr Konto.",
      heroSub: "Wir senden Ihnen einen Link an Ihre hinterlegte E-Mail-Adresse.",
      requestTitle: "Passwort zurücksetzen",
      requestSub: "Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen sicheren Link, mit dem Sie ein neues Passwort festlegen können.",
      sendLink: "Link senden",
      privacyHint: "Aus Sicherheitsgründen bestätigen wir nicht, ob ein Konto existiert. Falls eines existiert, ist die E-Mail unterwegs.",
      sentTitle: "Wir sind dran.",
      sentSub: "Wenn ein Konto zu dieser E-Mail-Adresse existiert, haben wir Ihnen soeben einen Link geschickt. Bitte prüfen Sie auch Ihren Spam-Ordner.",
      confirmHeroLine: "Ein Schritt. Und Sie sind wieder sicher angemeldet.",
      confirmTitle: "Neues Passwort festlegen",
      confirmSub: "Bitte wählen Sie ein neues Passwort. Mindestens 8 Zeichen.",
      newPassword: "Neues Passwort",
      repeatPassword: "Passwort wiederholen",
      savePassword: "Passwort speichern",
      passwordTooShort: "Bitte mindestens 8 Zeichen wählen.",
      passwordMismatch: "Die Passwörter stimmen nicht überein.",
      linkInvalid: "Dieser Link ist nicht mehr gültig.",
      linkInvalidSub: "Der Link wurde bereits verwendet oder ist abgelaufen. Bitte fordern Sie einen neuen an.",
      requestNew: "Neuen Link anfordern",
      doneTitle: "Passwort gespeichert.",
      doneSub: "Sie werden gleich zur Anmeldung weitergeleitet.",
    },
    common: {
      cancel: "Abbrechen",
      save: "Speichern",
      loading: "Wird geladen...",
      backHome: "Zurück zur Startseite",
    },
    footer: {
      tag: "Sie kaufen das gute Gefühl, dass alles geregelt ist.",
      security: "So schützen wir Ihre Daten",
      privacy: "Datenschutz",
      imprint: "Impressum",
    },
    cookie: {
      title: "Cookies – kurz und ehrlich",
      body: "Wir verwenden ausschließlich technisch notwendige Cookies, damit Sie sicher angemeldet bleiben. Keine Tracker, keine Werbung, keine Drittanbieter.",
      accept: "Verstanden",
      learnMore: "Mehr erfahren",
      aria: "Hinweis zu Cookies",
    },
    trustHints: {
      dashboard: "Ihre Daten werden durch die eingesetzte Speicherinfrastruktur verschlüsselt gespeichert. Der Zugriff ist an Ihre Anmeldung gebunden.",
      vault: "Ihre Dokumente werden durch die eingesetzte Speicherinfrastruktur verschlüsselt gespeichert. Der Zugriff innerhalb der Anwendung ist an Ihre Anmeldung gebunden.",
      trustCard: "Sie bestimmen, welche Informationen die Vertrauenskarte zeigt — und können sie jederzeit sperren.",
      emergencyPortal: "Diese Seite zeigt ausschließlich, was der Inhaber freigegeben hat.",
    },
    legal: {
      impressum: {
        title: "Impressum",
        intro: "Angaben gemäß § 5 TMG.",
        sections: [
          {
            title: "Anbieter",
            body: [
              "Agentur SKUT",
              "Inhaber: Stefan Michael Knüttel",
              "Unter-Kohlgraben 84",
              "36129 Gersfeld/Rhön",
              "Deutschland",
            ],
          },
          {
            title: "Kontakt",
            body: [
              "Telefon: 0176 57742180",
              "E-Mail: info@sk-ut.de",
            ],
          },
          {
            title: "Streitbeilegung",
            body: [
              "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr.",
              "Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
            ],
          },
        ],
      },
      datenschutz: {
        title: "Datenschutzerklärung",
        intro: "Diese Erklärung beschreibt, welche Daten wir verarbeiten, warum wir das tun und welche Rechte Sie haben. Bewusst kurz und verständlich.",
        sections: [
          {
            title: "Verantwortlicher",
            body: [
              "Verantwortlich für die Datenverarbeitung ist die Agentur SKUT, Inhaber Stefan Michael Knüttel, Unter-Kohlgraben 84, 36129 Gersfeld/Rhön, Deutschland.",
              "Datenschutzbezogene Anfragen: privacy@allesgeregelt.app.",
            ],
          },
          {
            title: "Welche Daten wir verarbeiten",
            body: ["Wir verarbeiten ausschließlich die Daten, die Sie uns selbst anvertrauen:"],
            bullets: [
              "Konto-Daten: Vorname, Nachname, E-Mail-Adresse, gehashtes Passwort (bcrypt).",
              "Inhalts-Daten: Ihre Lebensbereiche, Aufgaben, Notfallkontakte, Vertrauenskarten-Einstellungen.",
              "Dokumente: Dateien, die Sie freiwillig in Ihren Vault hochladen.",
              "Technische Protokolle: Geräte- und Browser-Typ, anonymisierte IP-Adresse, Zeitpunkt der Anmeldung — ausschließlich zum Schutz vor Missbrauch.",
            ],
          },
          {
            title: "Warum wir Ihre Daten verarbeiten",
            body: ["Rechtsgrundlage ist in der Regel die Erfüllung des Nutzungsvertrags (Art. 6 Abs. 1 lit. b DSGVO) und unser berechtigtes Interesse an einer sicheren Plattform (Art. 6 Abs. 1 lit. f DSGVO). Wir verarbeiten Daten zu folgenden Zwecken:"],
            bullets: [
              "Bereitstellung Ihres persönlichen Kontos und Ihrer Inhalte.",
              "Sicherer Schutz vor unberechtigtem Zugriff (Brute-Force-Schutz, Sitzungs-Übersicht).",
              "Versand von rein transaktionalen E-Mails (z. B. Passwort-Reset).",
              "Auf ausdrückliche Anfrage: Datenexport oder Konto-Löschung.",
            ],
          },
          {
            title: "Wo Ihre Daten gespeichert werden",
            body: [
              "Für den Betrieb von ALLES GEREGELT. setzen wir externe Dienstleister ein, insbesondere für Hosting, Datenbank, Dateispeicherung und E-Mail-Versand. Informationen zu den eingesetzten Dienstleistern, Verarbeitungsstandorten und den jeweils geltenden datenschutzrechtlichen Garantien werden in unserer Datenschutzerklärung bzw. der aktuellen Dienstleisterübersicht bereitgestellt.",
            ],
          },
          {
            title: "Warteliste (Pre-Launch)",
            body: [
              "Wenn Sie sich in unsere Warteliste eintragen, verarbeiten wir ausschließlich Ihre E-Mail-Adresse. Rechtsgrundlage ist Ihre Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO.",
              "Zur Sicherstellung, dass die Adresse tatsächlich Ihnen gehört, verwenden wir ein Double-Opt-in-Verfahren: Sie erhalten eine E-Mail mit einem Bestätigungslink. Erst nach dem Klick auf diesen Link wird Ihre Anmeldung wirksam.",
              "Wir speichern zusätzlich den Zeitpunkt Ihrer Anmeldung, den Zeitpunkt Ihrer Bestätigung und die Version des Einwilligungstextes (waitlist-v1), damit wir Ihre Einwilligung nachweisen können.",
              "Nicht bestätigte Anmeldungen werden nach Ablauf des Bestätigungszeitraums automatisch gelöscht.",
              "Für den Versand der E-Mails setzen wir den Dienstleister Resend (Resend.com) als Auftragsverarbeiter ein. Weitere Angaben zur Datenverarbeitung durch Resend ergänzen wir, sobald diese für unseren Account verbindlich vorliegen.",
              "Sie können Ihre Einwilligung jederzeit widerrufen: über den Abmeldelink in jeder E-Mail, über /waitlist/abmelden oder per E-Mail an privacy@allesgeregelt.app.",
              "Nach dem Widerruf entfernen wir Ihre E-Mail-Adresse im Klartext. Es verbleibt lediglich eine technische Kennung (Hash), damit Ihre Adresse nicht versehentlich erneut kontaktiert wird und Ihr Widerruf nachweisbar bleibt.",
              "Ihre Waitlist-Anmeldung erzeugt kein Nutzerkonto und ist von den Konto- und Produktdaten unserer Plattform vollständig getrennt.",
            ],
          },
          {
            title: "Cookies",
            body: [
              "Wir verwenden ausschließlich technisch notwendige Cookies, damit Sie sicher angemeldet bleiben. Wir nutzen keine Tracker, keine Werbe-Cookies und keine Drittanbieter zur Analyse.",
            ],
          },
          {
            title: "Wie lange wir Ihre Daten speichern",
            body: [
              "Solange Sie Ihr Konto nutzen, bleiben Ihre Daten bei Ihnen. Wenn Sie Ihr Konto schließen, werden Ihre Konto- und Metadaten dauerhaft aus unserer Datenbank entfernt. Für hochgeladene Dateien gelten die jeweils beschriebenen Speicher- und Löschverfahren. Reset-Anfragen werden nach 30 Minuten automatisch gelöscht.",
            ],
          },
          {
            title: "Ihre Rechte",
            body: ["Sie haben das Recht auf:"],
            bullets: [
              "Auskunft über die zu Ihrer Person gespeicherten Daten (Art. 15 DSGVO).",
              "Berichtigung unrichtiger Daten (Art. 16 DSGVO).",
              "Löschung Ihrer Daten (Art. 17 DSGVO) — direkt in Ihren Einstellungen.",
              "Datenübertragbarkeit (Art. 20 DSGVO) — direkt als ZIP-Export in Ihren Einstellungen.",
              "Widerspruch und Beschwerde bei einer Datenschutz-Aufsichtsbehörde.",
            ],
          },
          {
            title: "Notfall-Freigaben",
            body: [
              "Wenn Sie eine Vertrauenskarte einrichten, entscheiden Sie selbst, welche Informationen im Ernstfall sichtbar sind. Sie können die Karte jederzeit sperren oder den Zugriffsschlüssel neu erzeugen. Jeder Zugriff wird protokolliert (mit anonymisierter IP).",
            ],
          },
          {
            title: "Änderungen dieser Erklärung",
            body: [
              "Wir aktualisieren diese Erklärung, wenn sich unsere Prozesse oder rechtliche Rahmenbedingungen ändern. Wesentliche Änderungen kündigen wir innerhalb der Plattform an.",
            ],
          },
        ],
      },
      sicherheit: {
        title: "So schützen wir Ihre Daten",
        intro: "ALLES GEREGELT bewahrt sensible Informationen aus Ihrem Leben auf. Auf dieser Seite erklären wir in einfacher Sprache, wie wir das tun — ohne Fachsprache.",
        promiseTitle: "Unser Versprechen",
        promiseBody: "Sie kaufen keine Software. Sie kaufen das gute Gefühl, dass alles geregelt ist. Sicherheit ist für uns kein Premium-Feature, sondern die Grundlage — sie gilt für jeden Menschen, der diese Plattform nutzt.",
        principles: [
          {
            title: "Verschlüsselte Speicherung",
            body: "Dokumente und andere gespeicherte Inhalte werden durch die eingesetzte Speicherinfrastruktur verschlüsselt gespeichert. Der Zugriff innerhalb der Anwendung ist an die vorgesehenen Authentifizierungs- und Berechtigungsmechanismen gebunden.",
          },
          {
            title: "Sie behalten die Kontrolle",
            body: "Nur Sie entscheiden, wer Ihre Informationen sieht. Sie können jederzeit alles widerrufen — bis hin zur vollständigen Konto-Löschung.",
          },
          {
            title: "Geschützte Datenverarbeitung",
            body: "Für den technischen Betrieb setzen wir spezialisierte Dienstleister ein. Dabei gelten die jeweils anwendbaren datenschutzrechtlichen und vertraglichen Schutzmaßnahmen.",
          },
          {
            title: "Sichere Anmeldung",
            body: "Anmeldungen sind durch verschlüsselte Verbindungen, geprüfte Passwörter und einen Schutz gegen automatisierte Angriffe gesichert. Beendete Sitzungen sind sofort ungültig.",
          },
          {
            title: "Klare Notfall-Freigaben",
            body: "Ihre Vertrauenskarte zeigt nur das, was Sie freigegeben haben. Jeder Zugriff wird protokolliert, und Sie können die Karte mit einem Klick sperren.",
          },
          {
            title: "Keine Tracker, keine Werbung",
            body: "Wir verkaufen Ihre Daten nicht. Wir analysieren Ihr Verhalten nicht. Wir nutzen keine Drittanbieter-Tracker. Punkt.",
          },
        ],
        sections: [
          {
            title: "Wie Sie selbst sicher bleiben",
            body: "Wählen Sie ein Passwort mit mindestens acht Zeichen, das Sie nirgendwo sonst verwenden. Schauen Sie regelmäßig in Ihre Sitzungs-Übersicht und beenden Sie alles, was Sie nicht kennen. Wenn Sie unsicher sind, schreiben Sie uns — wir helfen.",
          },
          {
            title: "Was passiert bei einem Sicherheitsvorfall?",
            body: "Sollte einmal etwas Unvorhergesehenes geschehen, informieren wir betroffene Nutzerinnen und Nutzer schnell, ehrlich und in einfacher Sprache. Wir verstecken keine Probleme — wir lösen sie.",
          },
          {
            title: "Sie haben Fragen?",
            body: "Schreiben Sie uns an security@allesgeregelt.app. Wir antworten persönlich.",
          },
        ],
        closing: "Sicherheit darf sich anfühlen wie Ruhe. Genau das ist unser Maßstab.",
      },
    },
    lina: {
      title: "LINA",
      sub: "Ihre ruhige Begleiterin",
    },
    trustCard: {
      title: "Ihre persönliche Vertrauenskarte",
      subtitle: "Mit der Vertrauenskarte können berechtigte Personen im Ernstfall sicher auf die von Ihnen freigegebenen Informationen zugreifen. Sie entscheiden jederzeit selbst, welche Informationen sichtbar sind.",
      preview: "Kartenvorschau",
      cardLabel: "VERTRAUENSKARTE",
      notfallId: "Notfall-ID",
      scanHint: "Im Notfall bitte QR-Code scannen.",
      actions: {
        digital: "Digitale Karte",
        pdf: "PDF herunterladen",
        print: "Karte drucken",
        appleWallet: "Apple Wallet",
        googleWallet: "Google Wallet",
        nfc: "NFC einrichten",
        soon: "Bald verfügbar",
      },
      permissions: {
        title: "Notfallfreigaben",
        sub: "Für jede Information bestimmen Sie selbst, ob sie im Notfall sichtbar ist.",
        groups: {
          medical: "Medizin",
          contacts: "Kontakte",
          documents: "Dokumente",
          notes: "Hinweise",
        },
        items: {
          blood_type: "Blutgruppe",
          allergies: "Allergien",
          medications: "Medikamente",
          hausarzt: "Hausarzt",
          krankenkasse: "Krankenkasse",
          organ_donor: "Organspende",
          partner: "Partner/in",
          kinder: "Kinder",
          eltern: "Eltern",
          notfallkontakte: "Notfallkontakte",
          patientenverfuegung: "Patientenverfügung",
          vorsorgevollmacht: "Vorsorgevollmacht",
          betreuungsverfuegung: "Betreuungsverfügung",
          notfallmappe: "Notfallmappe",
          pets: "Haustiere",
          care_notes: "Pflegehinweise",
          important_info: "Wichtige Informationen",
        },
        accessMode: {
          title: "Wer darf diese Informationen sehen?",
          qr_only: "Jede Person mit QR-Code",
          verified: "Nur nach zusätzlicher Verifizierung",
          named_only: "Nur benannte Notfallkontakte",
          never: "Niemand · Notfallzugang deaktiviert",
        },
      },
      content: {
        title: "Informationen für den Notfall",
        sub: "Diese Daten werden nur dann gezeigt, wenn Sie sie oben freigeben.",
        save: "Speichern",
        fields: {
          blood_type: "Blutgruppe",
          allergies: "Allergien",
          medications: "Medikamente",
          hausarzt: "Hausarzt",
          krankenkasse: "Krankenkasse",
          organ_donor: "Organspendeausweis vorhanden",
          pets: "Haustiere",
          care_notes: "Pflegehinweise",
          important_info: "Wichtige Informationen",
        },
      },
      security: {
        title: "Sicherheit",
        regenerate: "QR-Code erneuern",
        regenerateHint: "Der alte QR-Code wird sofort ungültig.",
        lock: "QR-Code sperren",
        unlock: "QR-Code aktivieren",
        locked: "Diese Karte ist gesperrt.",
        active: "Diese Karte ist aktiv.",
        regenerated: "Neue Karte erstellt. Bitte druckbare Karte erneut speichern.",
        blockedItems: "Niemals zugänglich: Passwörter · Bankdaten · Testament · Tresor · Dokumente",
      },
      log: {
        title: "Zugriffschronik",
        sub: "Jede Notfallabfrage wird protokolliert.",
        empty: "Noch keine Zugriffe.",
        when: "Zeit",
        ip: "IP (anonymisiert)",
        device: "Gerät",
        browser: "Browser",
        country: "Land",
        status: "Status",
        statusOk: "Erfolgreich",
        statusError: "Fehler",
        showAll: "Alle anzeigen",
        showLess: "Weniger anzeigen",
      },
      notifications: {
        title: "Benachrichtigungen",
        sub: "Sie erhalten eine Nachricht, sobald jemand Ihre Vertrauenskarte verwendet.",
        channels: {
          email: "E-Mail",
          push: "Push-Nachricht",
          sms: "SMS",
          whatsapp: "WhatsApp",
          wallet: "Apple / Google Wallet",
          smartwatch: "Smartwatch",
          none: "Keine Benachrichtigung",
        },
        soon: "bald",
        trustedContacts: "Auch Vertrauenskontakte benachrichtigen",
        trustedContactsSub: "Falls Sie selbst nicht reagieren können, werden auch Ihre freigegebenen Notfallkontakte informiert.",
        autoLock: "Automatische Sperre bei verdächtigen Zugriffen",
        autoLockSub: "Wird die Karte ungewöhnlich oft in kurzer Zeit abgerufen, sperrt sie sich selbst und Sie werden benachrichtigt.",
        threshold: "Zugriffe in 10 Minuten",
      },
      lockedPage: {
        title: "Vertrauenskarte gesperrt",
        sub: (n) => `${n ? n + ", Ihre" : "Ihre"} Vertrauenskarte wurde soeben gesperrt. Der QR-Code ist sofort ungültig.`,
        next: "Was als Nächstes?",
        nextItems: [
          "Sie können in der App eine neue Karte erzeugen.",
          "Bis dahin kann niemand mehr Ihr Notfallportal aufrufen.",
          "Bitte prüfen Sie Ihre Zugriffschronik in Ruhe.",
        ],
        openApp: "Zur App",
        invalid: "Dieser Sperr-Link ist ungültig oder abgelaufen.",
        already: "Diese Karte war bereits gesperrt.",
      },
      trustCheck: {
        title: "Vertrauens-Check",
        sub: "Prüft mit einem Klick, ob Ihr gesamtes Notfallsystem funktioniert. Ohne echte Daten zu verändern.",
        start: "Vertrauens-Check starten",
        running: "Prüfung läuft…",
        clearTest: "Test-Einträge entfernen",
        successTitle: "Vertrauens-Check erfolgreich abgeschlossen",
        failTitle: "Vertrauens-Check mit Hinweisen abgeschlossen",
        ok: "Einsatzbereit",
        notOk: "Eingeschränkt",
        checked: "Geprüft wurden:",
        systemStatus: "Systemstatus",
        plannedTitle: "Geplante Tests",
        plannedSub: "Diese Tests folgen in einer späteren Version.",
        lastCheck: "Letzte Vertrauensprobe",
        never: "noch nie durchgeführt",
        demoOnly: "Demo-Modus: Beispielgeräte werden rotiert.",
        liveOnly: "Live-Modus: nur reale Zugriffe werden geprüft.",
      },
      systemBox: {
        title: "Vertrauenssystem",
        items: {
          card_active: "Vertrauenskarte aktiv",
          qr_valid: "QR-Code gültig",
          portal: "Notfallportal erreichbar",
          notif: "Benachrichtigung aktiv",
          log: "Vertrauensprotokoll aktiv",
        },
        lastCheck: "Letzte Vertrauensprobe",
      },
    },
    emergencyPortal: {
      title: "Notfallportal",
      subtitle: "Diese Informationen wurden vom Eigentümer freiwillig für den Notfall freigegeben.",
      ownerLabel: "Inhaber:in",
      notfallIdLabel: "Notfall-ID",
      verifyTitle: "Verifizierung erforderlich",
      verifySub: "Der Inhaber hat zusätzliche Verifizierung vorgesehen. Bitte kontaktieren Sie eine der unten genannten Personen.",
      sectionMedical: "Medizinische Hinweise",
      sectionContacts: "Vertrauenspersonen",
      sectionDocuments: "Vorsorge-Dokumente",
      sectionNotes: "Weitere Hinweise",
      empty: "Keine Daten in dieser Kategorie freigegeben.",
      lockedTitle: "Karte gesperrt",
      lockedSub: "Diese Vertrauenskarte wurde vom Inhaber widerrufen.",
      notFoundTitle: "Unbekannte Karte",
      notFoundSub: "Diese Vertrauenskarte ist nicht mehr gültig.",
      footer: "Dieser Notfallzugang ist kryptografisch gesichert und auf Wunsch des Inhabers eingeschränkt.",
      organYes: "Ja",
      organNo: "Nein",
    },
    shop: {
      title: "Physische Karte (bald verfügbar)",
      sub: "Eine hochwertige Karte zum Mitnehmen – im Portemonnaie, an der Pinnwand, am Schlüsselbund.",
      badge: "In Vorbereitung",
      notify: "Benachrichtigen, sobald verfügbar",
      info: "Die digitale Vertrauenskarte ist und bleibt kostenlos. Eine physische Karte können Sie später optional bestellen.",
      variants: {
        "card-pvc-classic": { name: "PVC Classic", desc: "Stabile Plastikkarte im Scheckkartenformat." },
        "card-pvc-nfc":     { name: "PVC mit NFC", desc: "Wie Classic, zusätzlich NFC-Tag für Smartphones." },
        "card-metal-noir":  { name: "Metal Noir", desc: "Premium-Metallkarte. Schwarz. Diskret." },
        "card-wood-eco":    { name: "Wood Eco", desc: "Nachhaltiges Holzfurnier. Warm im Griff." },
        "card-recycled":    { name: "Recycled Ocean", desc: "Aus recyceltem Ozean-Plastik." },
      },
    },
  },
  en: {
    appName: "ALL TAKEN CARE OF",
    appTag: "LIFE CORE",
    tagline: "You are not buying software. You are buying the good feeling that everything is taken care of.",
    nav: {
      myLife: "My Life",
      lifeTree: "Life Tree",
      vault: "Vault",
      tasks: "Tasks",
      emergency: "Emergency",
      family: "Family",
      trustCard: "Trust Card",
      settings: "Settings",
    },
    auth: {
      login: "Sign in",
      register: "Create account",
      email: "Email",
      password: "Password",
      firstName: "First name",
      lastName: "Last name",
      orDivider: "or",
      google: "Continue with Google",
      demoTitle: "Demo mode",
      demoSub: "Experience the app with Stefan Muster's data.",
      demoStart: "Enter demo mode",
      noAccount: "No account yet?",
      hasAccount: "Already have an account?",
      welcome: "Welcome back",
      welcomeNew: "Glad you're here",
      submitLogin: "Sign in",
      submitRegister: "Create account",
      logout: "Sign out",
    },
    onboarding: {
      step1Title: "Glad you're here.",
      step1Sub: "No one needs to finish everything in a day. Just 10 minutes are enough to take care of something important.",
      step2Title: "What would you like to take care of first?",
      step2Sub: "Pick the areas that matter to you. You can change this any time.",
      step3Title: "Your first emergency contact",
      step3Sub: "A trusted person to be informed in case of emergency.",
      step3Skip: "I'll do this later",
      step4Title: "Ready for your dashboard",
      step4Sub: "Step by step. You are safe here.",
      continue: "Continue",
      skip: "Skip",
      finish: "Open dashboard",
    },
    dashboard: {
      greeting: (n) => `Good morning, ${n}.`,
      subline: "In just 8 minutes today, you can take care of three important things.",
      trustRing: "Trust Status",
      segments: {
        vollstaendigkeit: "Completeness",
        aktualitaet: "Up-to-date",
        sicherheit: "Security",
        notfallbereitschaft: "Emergency readiness",
      },
      thisWeek: (d) => `+${d}% this week`,
      openTasks: "Open recommendations",
      seeAll: "See all",
      lifeTree: "Life Tree",
    },
    statuses: {
      alles_geregelt: "All taken care of",
      teilweise_geregelt: "Partly taken care of",
      handlungsbedarf: "Needs attention",
    },
    vault: {
      title: "Document Vault",
      subtitle: "Your important documents. Safely transferred. Stored encrypted. Organized.",
      upload: "Upload document",
      search: "Search...",
      all: "All",
      empty: "No documents yet. Upload your first one and add a little more safety to your day.",
      titleField: "Title",
      category: "Category",
      description: "Description",
      tags: "Tags (comma separated)",
      expiry: "Expiry date",
      reminder: "Reminder date",
      file: "Choose file",
      save: "Upload",
      cancel: "Cancel",
      open: "Open",
      edit: "Edit",
      delete: "Delete",
      categories: {
        ausweise: "IDs",
        gesundheit: "Health",
        versicherungen: "Insurance",
        finanzen: "Finance",
        zuhause: "Home",
        familie: "Family",
        vorsorge: "Advance care",
        nachlass: "Estate",
        business: "Business",
        sonstiges: "Other",
      },
    },
    tasks: {
      title: "Tasks & Recommendations",
      subtitle: "Small steps. Big effect.",
      empty: "Nothing urgent right now. Enjoy your day.",
      done: "Done",
      later: "Later",
      priorityHigh: "High",
      priorityNormal: "Normal",
      priorityLow: "Low",
      minutes: (m) => `${m} min`,
      addTask: "Add task",
    },
    emergency: {
      title: "Emergency Area",
      subtitle: "This area helps your loved ones quickly find the most important information when it matters.",
      addContact: "Add emergency contact",
      empty: "Add an emergency contact so the right person can be reached when it matters.",
      access: "Access granted",
      noAccess: "No access",
      relationship: "Relationship",
      phone: "Phone",
      email: "Email",
      notes: "Notes",
      name: "Name",
      save: "Save",
      cancel: "Cancel",
      delete: "Remove",
    },
    family: {
      title: "Family & Trusted People",
      subtitle: "Who has access. Who knows.",
    },
    lifeTree: {
      title: "Life Tree",
      subtitle: "Nine areas. One life.",
    },
    settings: {
      title: "Settings",
      language: "Language",
      german: "German",
      english: "English",
      account: "Account",
      presentation: "Presentation mode",
      presentationSub: "Soft animations. Curated data. Perfect for fairs and investors.",
      startPresentation: "Start presentation",
      stopPresentation: "Stop presentation",
      exitDemo: "Exit demo mode",
      sectionGeneral: "General",
      sectionProfile: "Profile",
      sectionSecurity: "Security",
      sectionPrivacy: "Data & privacy",
    },
    security: {
      profile: {
        title: "Profile",
        name: "Name",
        edit: "Edit",
        changeEmail: "Change email",
        changeEmailSub: "For security we need your current password before changing the sign-in email.",
        newEmail: "New email address",
        confirmPwd: "Current password",
        confirmPwdPlaceholder: "To confirm",
        authMethod: "Sign-in method",
        googleManaged: "These details are managed by your Google account.",
        avatarSaved: "Profile picture saved.",
        avatarError: "Could not save profile picture.",
        nameSaved: "Name updated.",
        emailSaved: "Email updated.",
        emailError: "Email could not be changed.",
      },
      security: {
        title: "Security",
        password: "Password",
        passwordSub: "Choose something memorable for you – but unguessable for anyone else.",
        changePassword: "Change password",
        changePasswordSub: "Enter your current password and choose a new one.",
        currentPwd: "Current password",
        pwdSaved: "Password updated.",
        pwdError: "Could not change password.",
        mfa: "Two-factor sign-in",
        mfaSub: "Extra protection with authenticator app or passkey. We are preparing this carefully.",
        mfaMethods: "Planned methods",
        comingSoon: "Coming soon",
        notify: "Notify me",
        sessions: "Active sessions",
        sessionsSub: "See where you are currently signed in. You can end individual sessions.",
        sessionsEmpty: "No sessions recorded yet.",
        sessionsNote: "New sign-ins on other devices are recorded automatically for your safety.",
        thisDevice: "This device",
        revoke: "Sign out",
        sessionRevoked: "Session ended.",
        sessionRevokeError: "Could not end this session.",
      },
      privacy: {
        title: "Data & privacy",
        exportTitle: "Export your data",
        exportSub: "Get a full machine-readable copy of all your data – including life tree, vault, tasks, contacts and emergency settings. (GDPR Art. 20)",
        exportBtn: "Download export",
        exportSuccess: "Export downloaded.",
        exportError: "Could not create export.",
        deleteTitle: "Close account",
        deleteSub: "When you close your account, all your data is removed irreversibly. This step cannot be undone.",
        deleteBtn: "Close account",
        deleteConfirmTitle: "Permanently delete your account?",
        deleteConfirmIntro: "You are about to remove your account and all related data forever. Please take a calm moment.",
        deleteList: [
          "Your life areas, tasks and recommendations will be deleted.",
          "All uploaded documents will be removed from the vault.",
          "Your Trust Card becomes invalid immediately.",
          "Your emergency contacts and notification settings will be removed.",
          "After confirmation, recovery is no longer possible.",
        ],
        confirmTypeLabel: (word) => `Type "${word}" to confirm`,
        confirmTypeWrong: "Please type the confirmation text exactly.",
        deleteFinal: "Yes, permanently delete",
        deleteSuccess: "Your account has been closed.",
        deleteError: "Could not delete account.",
      },
    },
    reset: {
      forgotLink: "Forgot password?",
      backToLogin: "Back to sign-in",
      heroLine: "We help you back into your account – calmly and safely.",
      heroSub: "We send a link to your registered email address.",
      requestTitle: "Reset password",
      requestSub: "Enter your email address. We will send a secure link so you can choose a new password.",
      sendLink: "Send link",
      privacyHint: "For security reasons we do not confirm whether an account exists. If one does, the email is on its way.",
      sentTitle: "We're on it.",
      sentSub: "If an account exists for this email, we just sent you a link. Please also check your spam folder.",
      confirmHeroLine: "One step. And you are safely signed back in.",
      confirmTitle: "Choose a new password",
      confirmSub: "Please choose a new password. At least 8 characters.",
      newPassword: "New password",
      repeatPassword: "Repeat password",
      savePassword: "Save password",
      passwordTooShort: "Please choose at least 8 characters.",
      passwordMismatch: "Passwords do not match.",
      linkInvalid: "This link is no longer valid.",
      linkInvalidSub: "The link was already used or expired. Please request a new one.",
      requestNew: "Request a new link",
      doneTitle: "Password saved.",
      doneSub: "You will be redirected to sign-in in a moment.",
    },
    common: {
      cancel: "Cancel",
      save: "Save",
      loading: "Loading...",
      backHome: "Back to home",
    },
    footer: {
      tag: "You buy the good feeling that everything is taken care of.",
      security: "How we protect your data",
      privacy: "Privacy",
      imprint: "Imprint",
    },
    cookie: {
      title: "Cookies — brief and honest",
      body: "We only use technically necessary cookies so you stay safely signed in. No trackers, no ads, no third parties.",
      accept: "Understood",
      learnMore: "Learn more",
      aria: "Cookie notice",
    },
    trustHints: {
      dashboard: "Your data is encrypted at rest by our storage infrastructure. Access is tied to your sign-in.",
      vault: "Your documents are encrypted at rest by our storage infrastructure. Access within the application is tied to your sign-in.",
      trustCard: "You decide what your Trust Card shows — and you can lock it at any time.",
      emergencyPortal: "This page only shows what the owner has shared.",
    },
    legal: {
      impressum: {
        title: "Legal notice",
        intro: "Information according to § 5 TMG (German Telemedia Act).",
        sections: [
          { title: "Provider", body: ["Agentur SKUT", "Owner: Stefan Michael Knüttel", "Unter-Kohlgraben 84", "36129 Gersfeld/Rhön", "Germany"] },
          { title: "Contact", body: ["Phone: 0176 57742180", "Email: info@sk-ut.de"] },
          {
            title: "Dispute resolution",
            body: [
              "The European Commission provides an online dispute resolution platform (ODR): https://ec.europa.eu/consumers/odr.",
              "We are not obliged and not willing to participate in dispute resolution proceedings before a consumer arbitration board.",
            ],
          },
        ],
      },
      datenschutz: {
        title: "Privacy policy",
        intro: "This page describes which data we process, why we do so and which rights you have. Intentionally short and easy to understand.",
        sections: [
          { title: "Controller", body: ["Controller in the sense of GDPR is Agentur SKUT, owner Stefan Michael Knüttel, Unter-Kohlgraben 84, 36129 Gersfeld/Rhön, Germany.", "Data protection contact: privacy@allesgeregelt.app."] },
          {
            title: "What data we process",
            body: ["We only process the data you entrust to us:"],
            bullets: [
              "Account data: first name, last name, email, hashed password (bcrypt).",
              "Content data: your life areas, tasks, emergency contacts, Trust Card settings.",
              "Documents: files you voluntarily upload to your vault.",
              "Technical logs: device, browser, anonymized IP, sign-in time — solely to protect against abuse.",
            ],
          },
          {
            title: "Why we process your data",
            body: ["Legal basis is usually contract performance (Art. 6 (1) (b) GDPR) and our legitimate interest in a secure platform (Art. 6 (1) (f) GDPR)."],
            bullets: [
              "Provide your personal account and content.",
              "Protect against unauthorized access (brute-force protection, session overview).",
              "Send transactional emails only (e.g. password reset).",
              "On explicit request: data export or account deletion.",
            ],
          },
          { title: "Where your data is stored", body: ["To operate ALLES GEREGELT. we engage external service providers, in particular for hosting, database, file storage and email delivery. Information about the service providers used, their processing locations and the applicable data-protection safeguards is provided in our privacy policy or the current processor overview."] },
          { title: "Cookies", body: ["We only use technically necessary cookies so you stay safely signed in. No trackers, no ad cookies, no third-party analytics."] },
          { title: "How long we keep your data", body: ["As long as you use your account, your data stays with you. When you close your account, your account and metadata are permanently removed from our database. Uploaded files are handled according to the storage and deletion procedures described in our privacy policy. Reset requests are auto-deleted after 30 minutes."] },
          {
            title: "Your rights",
            body: ["You have the right to:"],
            bullets: [
              "Information about data we hold about you (Art. 15 GDPR).",
              "Correction of inaccurate data (Art. 16 GDPR).",
              "Erasure of your data (Art. 17 GDPR) — directly in your settings.",
              "Data portability (Art. 20 GDPR) — directly as a ZIP export in your settings.",
              "Objection and complaint to a supervisory authority.",
            ],
          },
          { title: "Emergency releases", body: ["When you set up a Trust Card, you decide which information is visible in an emergency. You can lock the card or regenerate the access key at any time. Every access is logged (with anonymized IP)."] },
          { title: "Changes to this policy", body: ["We update this policy when our processes or the legal framework change. Material changes are announced inside the platform."] },
        ],
      },
      sicherheit: {
        title: "How we protect your data",
        intro: "ALLES GEREGELT holds sensitive information from your life. On this page we explain in simple language how we do it — without jargon.",
        promiseTitle: "Our promise",
        promiseBody: "You're not buying software. You're buying the good feeling that everything is taken care of. Security is not a premium feature for us — it's the foundation for everyone who uses this platform.",
        principles: [
          { title: "Encrypted storage", body: "Documents and other stored content are encrypted at rest by our storage infrastructure. Access within the application is bound to the designated authentication and authorization mechanisms." },
          { title: "You stay in control", body: "Only you decide who sees your information. You can revoke everything at any time — up to and including full account deletion." },
          { title: "Protected data processing", body: "For technical operations we engage specialized service providers. The applicable data-protection and contractual safeguards apply." },
          { title: "Secure sign-in", body: "Sign-ins are secured by encrypted connections, hashed passwords and brute-force protection. Ended sessions are invalid immediately." },
          { title: "Clear emergency releases", body: "Your Trust Card only shows what you have released. Every access is logged, and you can lock the card with one click." },
          { title: "No trackers, no ads", body: "We don't sell your data. We don't analyze your behavior. We don't use third-party trackers. Period." },
        ],
        sections: [
          { title: "How to stay safe yourself", body: "Pick a password with at least eight characters that you don't use anywhere else. Check your session overview regularly and sign out anything you don't recognize. If unsure, write to us — we're here." },
          { title: "What happens in a security incident?", body: "Should anything unexpected happen, we notify affected users quickly, honestly and in plain language. We don't hide issues — we solve them." },
          { title: "Questions?", body: "Write to security@allesgeregelt.app. We answer personally." },
        ],
        closing: "Security should feel like calm. That's exactly our benchmark.",
      },
    },
    lina: {
      title: "LINA",
      sub: "Your calm companion",
    },
    trustCard: {
      title: "Your personal Trust Card",
      subtitle: "With the Trust Card, authorized people can securely access the information you have released in an emergency. You decide at any time which information is visible.",
      preview: "Card preview",
      cardLabel: "TRUST CARD",
      notfallId: "Emergency ID",
      scanHint: "In an emergency, please scan the QR code.",
      actions: {
        digital: "Digital card",
        pdf: "Download PDF",
        print: "Print card",
        appleWallet: "Apple Wallet",
        googleWallet: "Google Wallet",
        nfc: "NFC setup",
        soon: "Coming soon",
      },
      permissions: {
        title: "Emergency releases",
        sub: "For each item you decide whether it is visible in an emergency.",
        groups: {
          medical: "Medical",
          contacts: "Contacts",
          documents: "Documents",
          notes: "Notes",
        },
        items: {
          blood_type: "Blood type",
          allergies: "Allergies",
          medications: "Medications",
          hausarzt: "Family doctor",
          krankenkasse: "Health insurance",
          organ_donor: "Organ donation",
          partner: "Partner",
          kinder: "Children",
          eltern: "Parents",
          notfallkontakte: "Emergency contacts",
          patientenverfuegung: "Living will",
          vorsorgevollmacht: "Power of attorney",
          betreuungsverfuegung: "Care directive",
          notfallmappe: "Emergency folder",
          pets: "Pets",
          care_notes: "Care notes",
          important_info: "Important info",
        },
        accessMode: {
          title: "Who may see this information?",
          qr_only: "Anyone with QR code",
          verified: "Only after additional verification",
          named_only: "Only named emergency contacts",
          never: "No one · Emergency access disabled",
        },
      },
      content: {
        title: "Emergency information",
        sub: "These fields are only shown when released above.",
        save: "Save",
        fields: {
          blood_type: "Blood type",
          allergies: "Allergies",
          medications: "Medications",
          hausarzt: "Family doctor",
          krankenkasse: "Health insurance",
          organ_donor: "Organ donor card",
          pets: "Pets",
          care_notes: "Care notes",
          important_info: "Important info",
        },
      },
      security: {
        title: "Security",
        regenerate: "Regenerate QR",
        regenerateHint: "The old QR code becomes invalid immediately.",
        lock: "Lock QR code",
        unlock: "Re-activate QR",
        locked: "This card is locked.",
        active: "This card is active.",
        regenerated: "New card created. Please re-print.",
        blockedItems: "Never accessible: Passwords · Banking · Will · Vault · Documents",
      },
      log: {
        title: "Access history",
        sub: "Every emergency look-up is logged.",
        empty: "No accesses yet.",
        when: "Time",
        ip: "IP (anonymized)",
        device: "Device",
        browser: "Browser",
        country: "Country",
        status: "Status",
        statusOk: "Successful",
        statusError: "Error",
        showAll: "Show all",
        showLess: "Show less",
      },
      notifications: {
        title: "Notifications",
        sub: "You receive a message whenever your Trust Card is used.",
        channels: {
          email: "Email",
          push: "Push notification",
          sms: "SMS",
          whatsapp: "WhatsApp",
          wallet: "Apple / Google Wallet",
          smartwatch: "Smartwatch",
          none: "No notification",
        },
        soon: "soon",
        trustedContacts: "Also notify trusted contacts",
        trustedContactsSub: "If you cannot react yourself, your released emergency contacts will also be informed.",
        autoLock: "Auto-lock on suspicious access",
        autoLockSub: "If the card is queried unusually often in a short time, it locks itself and you are notified.",
        threshold: "Accesses in 10 min",
      },
      lockedPage: {
        title: "Trust Card locked",
        sub: (n) => `${n ? n + ", your" : "Your"} Trust Card has just been locked. The QR code is invalid immediately.`,
        next: "What's next?",
        nextItems: [
          "You can create a new card in the app.",
          "Until then no one can access your emergency portal.",
          "Take your time to review the access log.",
        ],
        openApp: "Open app",
        invalid: "This lock link is invalid or expired.",
        already: "This card was already locked.",
      },
      trustCheck: {
        title: "Trust Check",
        sub: "One click to verify the entire emergency system. Without changing any real data.",
        start: "Start Trust Check",
        running: "Running…",
        clearTest: "Remove test entries",
        successTitle: "Trust Check completed successfully",
        failTitle: "Trust Check completed with notes",
        ok: "Ready",
        notOk: "Limited",
        checked: "Checked:",
        systemStatus: "System status",
        plannedTitle: "Planned tests",
        plannedSub: "These tests will follow in a later version.",
        lastCheck: "Last Trust Check",
        never: "never run",
        demoOnly: "Demo mode: example devices rotate.",
        liveOnly: "Live mode: only real accesses are checked.",
      },
      systemBox: {
        title: "Trust system",
        items: {
          card_active: "Trust Card active",
          qr_valid: "QR code valid",
          portal: "Emergency portal reachable",
          notif: "Notifications active",
          log: "Access log active",
        },
        lastCheck: "Last Trust Check",
      },
    },
    emergencyPortal: {
      title: "Emergency Portal",
      subtitle: "This information was voluntarily released by the owner for emergencies.",
      ownerLabel: "Owner",
      notfallIdLabel: "Emergency ID",
      verifyTitle: "Verification required",
      verifySub: "The owner requires additional verification. Please contact one of the people listed below.",
      sectionMedical: "Medical info",
      sectionContacts: "Trusted people",
      sectionDocuments: "Advance care documents",
      sectionNotes: "Further notes",
      empty: "No data released in this category.",
      lockedTitle: "Card locked",
      lockedSub: "This Trust Card has been revoked by the owner.",
      notFoundTitle: "Unknown card",
      notFoundSub: "This Trust Card is no longer valid.",
      footer: "This emergency access is cryptographically secured and limited by the owner's choice.",
      organYes: "Yes",
      organNo: "No",
    },
    shop: {
      title: "Physical card (coming soon)",
      sub: "A premium card to carry with you – in your wallet, on the fridge, on your keyring.",
      badge: "In preparation",
      notify: "Notify me when available",
      info: "The digital Trust Card is and remains free. A physical card will be available as an optional add-on.",
      variants: {
        "card-pvc-classic": { name: "PVC Classic", desc: "Sturdy plastic card in credit-card format." },
        "card-pvc-nfc":     { name: "PVC with NFC", desc: "Same as Classic, plus an NFC tag for smartphones." },
        "card-metal-noir":  { name: "Metal Noir", desc: "Premium black metal card. Discreet." },
        "card-wood-eco":    { name: "Wood Eco", desc: "Sustainable wood veneer. Warm to the touch." },
        "card-recycled":    { name: "Recycled Ocean", desc: "Made from recycled ocean plastic." },
      },
    },
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "de";
    return localStorage.getItem("ag_lang") || "de";
  });

  useEffect(() => {
    if (typeof window !== "undefined") localStorage.setItem("ag_lang", lang);
  }, [lang]);

  const t = dict[lang] || dict.de;
  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}

export const lifeAreaLabels = {
  de: {
    gesundheit: "Gesundheit",
    familie: "Familie",
    zuhause: "Zuhause",
    finanzen: "Finanzen",
    dokumente: "Dokumente",
    vorsorge: "Vorsorge",
    digital: "Digitales Leben",
    nachlass: "Nachlass",
    wuensche: "Wünsche",
  },
  en: {
    gesundheit: "Health",
    familie: "Family",
    zuhause: "Home",
    finanzen: "Finance",
    dokumente: "Documents",
    vorsorge: "Advance care",
    digital: "Digital life",
    nachlass: "Estate",
    wuensche: "Wishes",
  },
};
